import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Slider } from "antd";
import { useMemo } from "react";
import { ContentBlockerField, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { IRRELEVANT_VISUAL_TYPES } from "./visual-type.js";
import Logo from "../../../../../../assets/header/logo.svg";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldContentBlockerTemplateVisualBlur() {
    const { t } = useTranslation();
    const config = useMemo(()=>{
        return {
            slider: {
                marks: {
                    0: t("Disabled"),
                    5: "5%",
                    10: "10%",
                    15: "15%",
                    20: "20%"
                },
                min: 0,
                max: 20,
                style: {
                    marginLeft: 40,
                    marginRight: 40
                }
            },
            preview: {
                style: {
                    height: "6em",
                    padding: "1em",
                    backgroundColor: "black",
                    borderRadius: "1rem"
                }
            }
        };
    }, [
        t
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.VisualBlur,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prev, next)=>prev.isVisual !== next.isVisual || prev.visualType !== next.visualType || prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>(!IRRELEVANT_VISUAL_TYPES.includes(getFieldValue("visualType")) || !IRRELEVANT_VISUAL_TYPES.includes(getFieldValue(TemplateMetaDataField.Extends)?.["visualType"])) && /*#__PURE__*/ _jsx(Form.Item, {
                    label: getFieldNameTranslated(ContentBlockerField.VisualBlur, t),
                    extra: t("You can apply an additional blur to the background image. This can be useful e.g. for blocked contact forms to show it only schematically. Use this option only if it is unavoidable!"),
                    shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
                    required: true,
                    children: ({ getFieldValue })=>{
                        const extended = getFieldValue(TemplateMetaDataField.Extends);
                        const extendedVisualBlur = extended?.[ContentBlockerField.VisualBlur];
                        return /*#__PURE__*/ _jsxs(TemplateMetaDataExtendsStrategyFormField, {
                            extendsFieldName: ContentBlockerField.VisualBlur,
                            disableStrategies: getDisableStrategies(),
                            onKeepContent: extended && /*#__PURE__*/ _jsx(Form.Item, {
                                noStyle: true,
                                children: /*#__PURE__*/ _jsx(Slider, {
                                    defaultValue: extendedVisualBlur,
                                    ...config.slider,
                                    disabled: true
                                })
                            }),
                            children: [
                                /*#__PURE__*/ _jsx(Form.Item, {
                                    name: ContentBlockerField.VisualBlur,
                                    noStyle: true,
                                    children: /*#__PURE__*/ _jsx(Slider, {
                                        ...config.slider
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Form.Item, {
                                    noStyle: true,
                                    shouldUpdate: (prev, next)=>prev.visualBlur !== next.visualBlur,
                                    children: ({ getFieldValue })=>{
                                        return /*#__PURE__*/ _jsx("img", {
                                            src: Logo,
                                            style: {
                                                filter: `blur(${getFieldValue(ContentBlockerField.VisualBlur)}px)`,
                                                ...config.preview.style
                                            }
                                        });
                                    }
                                })
                            ]
                        });
                    }
                })
        })
    });
}
export { FormFieldContentBlockerTemplateVisualBlur };
